
export enum ReleaseType {
    Update = 1, 
    Upgrade = 2,
    Beta = 3,
}

export enum Level {
    Critical = 1,
    Noncritical = 2,
}

export enum ResourceType {
    Snape = 1,
    Mesh = 2,
    BeamBinaries = 3,
}

export type ResourceTypes = 'Snape' | 'Mesh' | 'Beam Binaries'

export interface NotificationData {
    ResourceType: ResourceType, //Snape, Mesh, BeamBinaries
    Level: Level, // 1 - Critical, 2 - Noncritical
    ReleaseType: ReleaseType, // 1 - Update, 2 - Upgrade, 3 - Beta
    Version: string
    HwVersion?: string
}

export interface NotificationDataResponse {
    IsMessagesEmpty: boolean,
    Status: string,
    data: NotificationData[] 
}
